import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import {
  SquareRemoveButton,
  TextButton,
} from '../../../../../components/Button';
import { useBootstrapSelector } from '../../../../../redux/selectorHooks';
import { assertNotNil } from '../../../../../utils/types';
import {
  defaultSchemaInspectSettingValue,
  IReportSettingsFormState,
} from '../types';
import CohortInspectReportSettingSchema from './CohortInspectReportSettingSchema';
import CohortInspectReportSettingFields from './CohortInspectReportSettingFields';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

const InspectSettingWrapper = styled.div`
  display: grid;
  grid-template-columns: 240px minmax(240px, max-content) auto;
  column-gap: 8px;
`;

const CohortInspectReportSettings = () => {
  const { control } = useFormContext<IReportSettingsFormState>();

  const schemaConfig = useBootstrapSelector('schemaConfig');
  assertNotNil(schemaConfig);
  const { allSchemas } = schemaConfig;

  const {
    fields: settings,
    prepend,
    remove,
  } = useFieldArray({
    name: 'inspect.schemaInspectSettings',
    control,
  });

  const handleAddInspectSetting = () => {
    prepend(defaultSchemaInspectSettingValue);
  };
  const handleRemoveInspectSetting = (settingIndex: number) => {
    remove(settingIndex);
  };

  return (
    <Container>
      <TextButton
        onClick={handleAddInspectSetting}
        disabled={settings.length === allSchemas.length}
      >
        + Add Default Fields
      </TextButton>
      {settings.map((setting, settingIndex) => (
        <InspectSettingWrapper key={setting.id}>
          <CohortInspectReportSettingSchema
            settingIndex={settingIndex}
            allSchemas={allSchemas}
          />
          <CohortInspectReportSettingFields settingIndex={settingIndex} />
          <SquareRemoveButton
            onClick={() => handleRemoveInspectSetting(settingIndex)}
            content={'Remove Setting'}
          />
        </InspectSettingWrapper>
      ))}
    </Container>
  );
};

export default CohortInspectReportSettings;
